import { adminTableEditorEpics } from './admin/table-editor';
import { coachingCardEpics } from './card--my-coaching-card/my-coaching-card.epic';
import { scorecardEpics } from './card--my-scorecard/my-scorecard.epic';
import { coachingCardRepEpics } from './card-coaching-card-rep/coaching-card-rep.epic';
import goalsCommitment from './coaching-commitment/commitment-goals/goals.commitment.epic';
import coachingCommitment from './coaching-commitment/commitment/commitment.epic';
import { coachingDetailPillarOneEpics } from './coaching-detail/pillar-one/pillar-one.epic';
import { coachingDetailPillarThreeEpics } from './coaching-detail/pillar-three/pillar-three.epic';
import { coachingDetailPillarTwoEpics } from './coaching-detail/pillar-two/pillar-two.epic';
import coachingCoverage from './coaching-insight/coaching-coverage/coaching-coverage.epic';
import coachingInsight from './coaching-insight/insight-widget/insight-widget.epic';
import coachingCalendar from './coaching-insight/schedule/calendar/calendar.epic';
import scheduleEvent from './coaching-insight/schedule/schedule-event/schedule-event.epic';
import kpiSet from './coaching-observation/observation-kpi-set/kpi-set.observation.epic';
import coachingObservationFocusSummary from './coaching-observation/observation-tag-group/observation.focus.summary.component/observation.focus.summary.epic';
import coachingObservation from './coaching-observation/observation/observation.epic';
import tagSet from './coaching-tags/tags/tags.epic';
import humanInsight from './human-insight/human-insight.epic';
import insightExplorer from './insight-explorer/insight-explorer.epic';
import insight from './insight/insight.epic';
import performanceInsight from './performance-insight/performance-insight.epic';
import scorecard from './scorecard/main-page/scorecard.epic';
import { scorecardWidgetEpics } from './scorecard/pulse-widget/pulse-widget.epic';
import * as tdcfForm from './tdcf-form/tdcf-form.epic';
import searchUser from './user/search-user.epic';

let out: any = [
    ...adminTableEditorEpics,
    ...coachingCalendar,
    ...coachingCommitment,
    ...coachingCoverage,
    ...coachingDetailPillarOneEpics,
    ...coachingDetailPillarThreeEpics,
    ...coachingDetailPillarTwoEpics,
    ...coachingInsight,
    ...coachingObservation,
    ...coachingObservationFocusSummary,
    ...goalsCommitment,
    ...humanInsight,
    ...insight,
    ...insightExplorer,
    ...kpiSet,
    ...performanceInsight,
    ...scheduleEvent,
    ...scorecard,
    ...scorecardWidgetEpics,
    ...searchUser,
    ...tagSet,
    ...coachingCardEpics,
    ...scorecardEpics,
    ...coachingCardRepEpics,
];

out = out.concat([
    tdcfForm.retrieveInitData,
    tdcfForm.formSave,
    tdcfForm.printRetrieveInitData,
    tdcfForm.reportRetrieveInitData,
    tdcfForm.reportGenerate,
]);

/** @deprecated */
export interface ActionResult<TAction, TResult> {
    action: TAction;
    result: TResult;
}

export default out;
